import { LocaleEnum } from './const';
import { getFallbackLng } from './fallbackLng/getFallbackLng';
/* eslint-disable @typescript-eslint/prefer-ts-expect-error,@typescript-eslint/ban-ts-comment -- process */
export const fallbackLng = getFallbackLng();

export const languages = [
  fallbackLng,
  'en',
  'de',
  'fr',
  'ar',
  'es',
  LocaleEnum.Arabic,
  LocaleEnum.Dutch,
  LocaleEnum.French,
  LocaleEnum.German,
  LocaleEnum.Hebrew,
  LocaleEnum.Italian,
  LocaleEnum.Spanish,
  LocaleEnum.Russian,
];
export const defaultNS = 'common';

// In native, Preload `blocks` alongside `common` (defaultNS) so it resolves inside this
// single init load instead of suspending on the first `useTranslation('blocks')`
// mid-render. Every no-code page renders block strings, so the namespace is
// always needed at first paint — folding it in here kills the ~200ms cold-start
// suspend (Suspense unwinds and re-renders the page subtree).
export const nativeDefaultNS = ['common', 'blocks']
export const cookieName = 'i18next';
// https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
export function getOptions(lng: string = fallbackLng, ns = defaultNS) {
  return {
    debug: false,
    supportedLngs: languages,
    fallbackLng: 'en', // since files are inside en folder
    nonExplicitSupportedLngs: true,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
    interpolation: {
      escapeValue: false,
    },
  };
}
